import httpRequest from "../utils/axios.js";
import config from "./config.js";

export default {
  getServerList,
  getValidCoupons,
  getMobileServer,
  getProductList,
  getOilCardList,
  getTransCardUrl,
  getServerPhone
};
/**
 * 首页获取服务
 */
export function getServerList(couponId) {
  var url = config.getServer + couponId;
  var jsondata = {};
  //getlist
  return httpRequest.fetchGet(url, jsondata);
}
/**
 * 首页获取服务客服热线
 */
export function getServerPhone() {
  var url = config.getServerPhone;
  var jsondata = {};
  //getlist
  return httpRequest.fetchGet(url, jsondata);
}
/**
 * 获取当前服务可用券
 */
export function getValidCoupons(categoryId, upstreamId, couponsBuyerUserId, mouldId) {
  var url = config.getService;
  var jsondata = {
    categoryId: categoryId,
    upstreamId: upstreamId,
    couponsBuyerUserId: couponsBuyerUserId,
    mouldId: mouldId
  };
  return httpRequest.fetchGet(url, jsondata);
}
/**
 * 查询话费流量服务商
 */
export function getMobileServer(mobile, type) {
  var url = config.mobileServe;
  var jsondata = {
    mobile: mobile,
    type: type
  };
  return httpRequest.fetchGet(url, jsondata);
}
/**
 * 查询面值
 */
export function getProductList(label, mouldId) {
  var url = config.getProductList;
  var jsondata = {
    label: label,
    mouldId: mouldId
  };
  //getlist
  return httpRequest.fetchGet(url, jsondata);
}
/**
 * 获取油卡列表
 */
export function getOilCardList() {
  var url = config.getOilCardList;
  var jsondata = {};
  return httpRequest.fetchGet(url, jsondata);
}
/**
 * 获取转让卡券链接
 */
export function getTransCardUrl(couponsId) {
  var url = config.transCardUrl;
  var jsondata = {
    couponsId
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 获取批量转让卡券链接
 */
export function getBatchTransCardUrl(couponsId) {
  var url = config.batchTransCardUrl;
  var jsondata = {
    couponsId
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 获取卡券批量转让url
 */
export function getBatchRecoveryUrl(couponsId) {
  var url = config.batchRecoveryUrl;
  var jsondata = {
    couponsId
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 获取卡券转让首页链接
 */
export function getRecoveryHomeUrl(couponsId) {
  var url = config.recoveryHomeUrl;
  var jsondata = {
    couponsId
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 根据手机号查询短信发券信息
 */
export function getCouponsInfoByMobile(mobile, current, size) {
  var url = config.couponsByMobile;
  var jsondata = {
    mobile,
    current,
    size
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 获取代驾券核销地址
 */
export function getDrivingCodeUrl(no) {
  var url = config.getDrivingCodeUrl;
  var jsondata = {
    no
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 购物卡购买
 */
export function buyShoppingCard(data) {
  var url = config.buyShoppingCard;
  return httpRequest.fetchPost(url, data);
}

/**
 * 视频购买
 */
export function buyVideo(data) {
  var url = config.buyVideo;
  return httpRequest.fetchPost(url, data);
}

/**
 * 获取视频订单信息
 */
export function getVideoOrder(videoOrderId, productId) {
  var url = config.getVideoOrder;
  var jsondata = {
    videoOrderId,
    productId
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 获取卡密信息
 */
export function getCardPwdInfo(orderId) {
  var url = config.getCardPwdInfo;
  var jsondata = {
    orderId
  };
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 查询用户退保支付金额
 */
export function getCancelInsuranceAmount() {
  var url = config.getCancelInsuranceAmount;
  return httpRequest.fetchGet(url);
}

/**
 * 查询用户退保支付金额
 */
export function getCancelInsuranceInfo() {
  var url = config.getCancelInsuranceInfo;
  return httpRequest.fetchGet(url);
}
/**
 * 获取银行卡列表
 */
export function getBankList() {
  var url = config.getBankList;
  var jsondata = {};
  return httpRequest.fetchGet(url, jsondata);
}

/**
 * 兑换微信红包，返回所需参数
 */
export function getRedPacketParamApi(data) {
  var url = '/api/v1.0/user/red-packet';
  return httpRequest.fetchPost(url, data);
}

/**
 * 订单页重新提现微信红包，返回所需参数
 */
export function redeemAgainWeChatRedPacketApi(orderNo) {
  var url = '/api/v1.0/user/package-info/' + orderNo;
  return httpRequest.fetchGet(url);
}

/**
 * 检查用户是否可以领取微信红包
 */
export function checkWeChatRedPacketClaimApi() {
  var url = '/api/v1.0/wechat/weChatRedPacket/claim-check';
  return httpRequest.fetchGet(url);
}

/**
 * 微信红包确认收款，将订单状态改为处理中
 */
export function retryClaimWeChatRedPacketClaimApi(orderNo) {
  var url = '/api/v1.0/wechat/weChatRedPacket/retry-claim/' + orderNo;
  return httpRequest.fetchPost(url);
}
